import './styles.css';

const ACCOUNTS = ['1', 'IB', 'JO'];

const AccountSwitcher = ({ value, onChange, onSubmit }) => {
  return (
    <div className="account-switcher">
      <select
        className="account-input"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        {ACCOUNTS.map((id) => (
          <option key={id} value={id}>
            {id}
          </option>
        ))}
      </select>
      <button className="button" onClick={onSubmit}>Zmień konto</button>
    </div>
  );
};

export default AccountSwitcher;
